import React from 'react';
import './Footer.css';
import { FlashIcon } from './Icons';
import { TwitterIcon, TelegramIcon, DiscordIcon, WebIcon, HeartIcon } from './SocialIcons';

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <FlashIcon size={28} color="#00d4ff" />
              <span className="logo-text">Flashseller</span>
              <span className="logo-domain">.in</span>
            </div>
            <p className="footer-description">
              Fast, secure, and reliable Flash USDT transactions. 
              Your trusted partner in crypto since 2024.
            </p>
            <div className="social-links">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Twitter">
                <TwitterIcon size={20} />
              </a>
              <a href="https://telegram.org" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Telegram">
                <TelegramIcon size={20} />
              </a>
              <a href="https://discord.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Discord">
                <DiscordIcon size={20} />
              </a>
              <a href="https://Flashseller.in" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Website">
                <WebIcon size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#how-it-works">How It Works</a></li>
              <li><a href="#features">Features</a></li>
              <li><a href="#roadmap">Roadmap</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#terms">Terms of Service</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Newsletter</h4>
            <p>Stay updated with our latest news and offers</p>
            <div className="newsletter-form">
              <input type="email" placeholder="Your email" />
              <button>Subscribe</button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 Flashseller.in - All rights reserved.</p>
          <p className="footer-love">
            Built with <HeartIcon size={16} color="#ef4444" /> for the crypto community
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
